import React from "react";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import style from "./HeaderInfo.module.scss";
import useNavigator from "../navigator/navigator";

const HeaderInfo = ({ onEditClick, title, onDelete }) => {
  const navigate = useNavigator();

  return (
    <div className={style.header}>
      <button className={style.iconButton} onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>
      <h2 className={style.title}>{title}</h2>
      <soan>
      <button className={style.iconButton} onClick={onEditClick}>
        <FaEdit />
      </button>
      <button className={style.iconButton} onClick={onDelete}>
        <FaTrash />
      </button>
      </soan>
     
    </div>
  );
};

export default HeaderInfo;